module.exports = __webpack_public_path__ + "img/RetroMetatarsi180_ok.fe69978a.png";